/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 住所マスタ情報DTO
 */
export interface AddressMasterDto { 
    /**
     * 住所コード
     */
    addressCode?: string;
    /**
     * 適用開始日付
     */
    applyStartDate?: string;
    /**
     * 適用終了日付
     */
    applyEndDate?: string;
    /**
     * 郵便番号
     */
    zipCode?: string;
    /**
     * 都道府県名称
     */
    prefecturesName?: string;
    /**
     * 市区郡町村名称
     */
    cityName?: string;
    /**
     * 町域名称
     */
    townAreaName?: string;
    /**
     * 大字丁目名称
     */
    ooazaName?: string;
    /**
     * 都道府県カナ名
     */
    prefecturesKanaName?: string;
    /**
     * 市区郡町村カナ名
     */
    cityKanaName?: string;
    /**
     * 町域カナ名
     */
    townAreaKanaName?: string;
    /**
     * 大字丁目カナ名
     */
    ooazaKanaName?: string;
    /**
     * 更新通番号
     */
    updateSrno?: string;
}

